// Module
var code = "<a data-ng-click=\"$ctrl.onClick()\" aria-label=\"Set default\"\n   class=\"tw-no-underline tw-opacity-50 tw-cursor-pointer hover:tw-opacity-100\">\n    Set Default\n</a>";
// Exports
module.exports = code;